var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7346 14.4463L10.8829 9.59362C11.6161 8.59501 12.0496 7.36351 12.0496 6.02991C12.0496 2.70548 9.34642 0 6.0248 0C2.70319 0 0 2.70548 0 6.02991C0 9.35434 2.70319 12.0598 6.0248 12.0598C7.36046 12.0598 8.5973 11.6227 9.59825 10.8826L14.4468 15.7352C14.6253 15.9139 14.858 16 15.0907 16C15.3234 16 15.5561 15.9107 15.7346 15.7352C16.0885 15.3779 16.0885 14.8036 15.7346 14.4463ZM6.02799 10.2413C3.70733 10.2413 1.82019 8.35254 1.82019 6.02991C1.82019 3.70728 3.70733 1.81854 6.02799 1.81854C8.34866 1.81854 10.2358 3.70728 10.2358 6.02991C10.2358 8.35254 8.34547 10.2413 6.02799 10.2413Z",
    fill: "#0B5D8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.ddcb4717daa1dba34141f0fa94042157.svg";
export { ForwardRef as ReactComponent };